// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItens_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/menu_itens/salvar
 *
 * Create or update a menu item. If menu_item_id is provided and > 0, updates existing item.
 */
import { registerContract } from './validate'

export interface MenuItens_SalvarInput {
menu_item_titulo: string
menu_item_id?: number
menu_item_tipo?: string
menu_item_icone?: string
menu_item_controller?: string
menu_item_pai_id?: string
menu_item_status?: number
menu_item_ordem?: number
menu_item_permissoes?: string
}

registerContract('MenuItens_SalvarInput', {
  menu_item_titulo:     { type: 'string',  required: true },
  menu_item_id:         { type: 'number',  required: false },
  menu_item_tipo:       { type: 'string',  required: false },
  menu_item_icone:      { type: 'string',  required: false },
  menu_item_controller: { type: 'string',  required: false },
  menu_item_pai_id:     { type: 'string',  required: false },
  menu_item_status:     { type: 'number',  required: false },
  menu_item_ordem:      { type: 'number',  required: false },
  menu_item_permissoes: { type: 'string',  required: false },
})
